import graphql__4b582e5d4e4827faacdc from "./__generated__/CompleteCityWalkContributionMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__4b582e5d4e4827faacdc;

function completeCityWalkContribution(contribution, onCompleted) {
  const variables = {
    contributionId: contribution.id
  };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { completeCityWalkContribution };
